import { Component } from '@angular/core';

@Component({
  selector: 'app-rate-esn',
  templateUrl: './rate-esn.component.html',
  styleUrls: ['./rate-esn.component.css'],
})
export class RateEsnComponent {}
